import { TextAreaField } from '@aws-amplify/ui-react'
import { List } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import CustomButton from '@/components/inputs/CustomButton'
import type { ControllerListIdentifier } from '@/features/controller/types'
import type { ControllerListIdentifiersParseResult } from '@/features/controller/utils/parseControllerListIdentifiers'
import { parseControllerListIdentifiers } from '@/features/controller/utils/parseControllerListIdentifiers'

interface ControllerListImporterProps {
  controllerList: ControllerListIdentifier[]
  onControllerListUpdated: (parseResult: ControllerListIdentifiersParseResult) => void
}

export function ControllerListImporter({
  controllerList,
  onControllerListUpdated,
}: Readonly<ControllerListImporterProps>) {
  const [controllerListText, setControllerListText] = useState<string>('')
  const { t } = useTranslation()

  useEffect(() => setControllerListText(controllerList.map((value) => value.rawValue).join(', ')), [controllerList])

  function handleListUpdated() {
    onControllerListUpdated(parseControllerListIdentifiers(controllerListText))
  }

  return (
    <Stack direction="column" spacing={1}>
      <TextAreaField
        label={t('controllers.bulk_actions.importer')}
        placeholder={t('controllers.bulk_actions.importer_placeholder')}
        value={controllerListText}
        onChange={(e) => setControllerListText(e.target.value)}
      />
      <Box>
        <CustomButton
          color="primary"
          startIcon={<List />}
          type="button"
          variant="contained"
          onClick={handleListUpdated}
        >
          {t('controllers.bulk_actions.importer_update_list')}
        </CustomButton>
      </Box>
    </Stack>
  )
}
